import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsNavigationRedesignEnabled } from "@src/appV2/redesign/hooks/useIsNavigationRedesignEnabled";

export function useIsDailyViewEnabled(): boolean {
  const isNavigationRedesignEnabled = useIsNavigationRedesignEnabled();
  const isDailyViewEnabled = useCbhFlag(CbhFeatureFlag.DAILY_VIEW_ENABLED, {
    defaultValue: false,
  });

  return isNavigationRedesignEnabled && isDailyViewEnabled;
}
